import { OrderProductKit } from '../../orders/products/orderProducts.types';
import { OrderProductSelectedPack } from '../../products/details/productDetails.types';
import { OfflineDatabaseKit } from '../database/offlineDatabase/types/offlineDatabaseKit.types';
import {
  OfflineDatabaseOrderProduct,
  OfflineDatabaseOrderProductKit,
} from '../database/offlineDatabase/types/offlineDatabaseOrder.types';
import { OfflineOrderProduct } from '../domain/offlineOrder/orderProduct/OfflineOrderProduct';

export class OfflineOrderProductTransformers {
  static toOfflineDatabaseOrderProduct(
    orderProduct: OfflineOrderProduct,
  ): OfflineDatabaseOrderProduct {
    return {
      kit: orderProduct.kit,
      grid: orderProduct.grid,
      packs: orderProduct.packs,
      product: orderProduct.product,
      metadata: orderProduct.metadata,
      createdAt: orderProduct.createdAt,
      productColor: orderProduct.productColor,
      availability: orderProduct.availability,
      deliveryWindow: orderProduct.deliveryWindow,
    };
  }

  static toOrderProductSelectedPack(orderProduct: OfflineOrderProduct): OrderProductSelectedPack[] {
    if (!orderProduct.packs) {
      return [];
    }

    return orderProduct.packs.map((orderProductPack) => ({
      packId: orderProductPack.pack.id,
      packName: orderProductPack.pack.name,
      quantity: orderProductPack.multiplier,
      packQuantitiesScreenshot: orderProductPack.pack.quantitiesBySize,
    }));
  }

  static offlineOrderProductKitToOrderProductKit(
    offlineOrderProductKit: OfflineOrderProduct['kit'],
  ): OrderProductKit | undefined {
    if (!offlineOrderProductKit) {
      return undefined;
    }

    return {
      id: offlineOrderProductKit.id,
      name: offlineOrderProductKit.name,
      code: offlineOrderProductKit.code,
      imageUrl: offlineOrderProductKit.imageUrl || undefined,
    };
  }

  static offlineKitToOrderProductKit(
    kit: OfflineDatabaseKit | undefined,
  ): OfflineDatabaseOrderProductKit | undefined {
    if (!kit) {
      return undefined;
    }

    return {
      id: kit.id,
      name: kit.name,
      code: kit.code,
      imageUrl: kit.imageUrl,
      active: kit.active,
      type: kit.type,
      description: kit.description,
      resume: kit.resume,
      wholesalePrice: kit.wholesalePrice,
      availableAmount: kit.availableAmount,
    };
  }
}
